// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/pregnancy */
export async function pregnancyControllerUpdate(
	body: API.PregnancyUpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/pregnancy', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/pregnancy/${param0} */
export async function pregnancyControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.PregnancyControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.PregnancyViewResponse>(`/api/pregnancy/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/pregnancy/${param0} */
export async function pregnancyControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.PregnancyControllerCreateParams,
	body: API.PregnancyCreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/pregnancy/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 DELETE /api/pregnancy/${param0}/${param1} */
export async function pregnancyControllerDelete(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.PregnancyControllerDeleteParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, id: param1, ...queryParams } = params;
	return request<boolean>(`/api/pregnancy/${param0}/${param1}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}
